import { render } from "./InviteTeamMember.vue?vue&type=template&id=6b87f3fc&ts=true"
import script from "./InviteTeamMember.vue?vue&type=script&lang=ts"
export * from "./InviteTeamMember.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__